export * from '@src/components/templates/tefOne/buttons.tmpl.js';
export * from '@src/components/templates/tefOne/comsParagraph.tmpl.js';
export * from '@src/components/templates/tefOne/consent.tmpl.js';
export * from '@src/components/templates/tefOne/consentOverview.tmpl.js';
export * from '@src/components/templates/tefOne/em.tmpl.js';
export * from '@src/components/templates/tefOne/features.tmpl.js';
export * from '@src/components/templates/tefOne/group.tmpl.js';
export * from '@src/components/templates/tefOne/history.tmpl.js';
export * from '@src/components/templates/tefOne/historyItem.tmpl.js';
export * from '@src/components/templates/tefOne/link.tmpl.js';
export * from '@src/components/templates/tefOne/main.tmpl.js';
export * from '@src/components/templates/tefOne/pagination.tmpl.js';
export * from '@src/components/templates/tefOne/referenceItem.tmpl.js';
export * from '@src/components/templates/tefOne/references.tmpl.js';
export * from '@src/components/templates/tefOne/tefComsCustomerAttribute.tmpl.js';
export * from '@src/components/templates/tefOne/tooltip.tmpl.js';
export * from '@src/components/templates/tefOne/triStateButton.tmpl.js';
export * from '@src/components/templates/tefOne/triStateButtonsPart.tmpl.js';
